// Core component styles
const coreStyles={button:{},buttonText:{}};/**
 * Helper method to get styles for this component
 * @param {Object} contextStyles - Styles for this component
 */const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{button:{...coreStyles.button,...contextStyles.button},buttonText:{...coreStyles.buttonText,...contextStyles.buttonText}};};export default getStyles;